import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { ETNotification } from '@src/app/models/ETnotification';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationitemService {

  constructor(private http:HttpClient) { }
  
  markRead(notification:ETNotification){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    notification.dateread = new Date().toISOString();
    // PUT /notification/{personId}/notification/{notificationId}
    return this.http.put<any>(environment.apiUrl+'/notification/'+SessionHelper.getUserSub()+'/date/'+notification.datecreated+'/notification/'+ notification.notificationId,JSON.stringify(notification),httpOptions);
  }
}
